import { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import Skeleton from 'react-loading-skeleton';

export const UnderlyingUniverseSkeleton: FC = () => (
  <div className="h-100 d-flex flex-column position-relative" data-e2e="underlying-universe">
    <div className="d-flex flex-row flex-wrap flex-md-nowrap gap-1 border-top border-bottom">
      <div className="d-flex flex-grow-1 px-16px align-items-center py-3">
        <h4 className="h5 lh-1">
          <FormattedMessage id="underlyingUniverse" />
        </h4>
      </div>
      <Skeleton width="20em" height="2em" />
      <Skeleton width="20em" height="2em" />
    </div>
    <div className="d-flex flex-column mt-3 vh-100">
      <div className="m-3 form-inline">
        <Skeleton width="20em" height="2em" />
        <div className="form-group ms-auto">
          <Skeleton width="2em" height="2em" />
        </div>
      </div>
      <table style={{ borderCollapse: 'collapse' }} className="m-3">
        <thead>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
          <th>
            <Skeleton width="100%" height="2em" />
          </th>
        </thead>
        <tbody>
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
          <SkeletonRow />
        </tbody>
      </table>
    </div>
  </div>
);

const SkeletonRow: FC = () => (
  <tr>
    <td>
      <Skeleton width="90%" height="2em" />
    </td>

    <td>
      <Skeleton width="90%" height="2em" />
    </td>

    <td>
      <Skeleton width="90%" height="2em" />
    </td>

    <td>
      <Skeleton width="90%" height="2em" />
    </td>

    <td>
      <Skeleton width="90%" height="2em" />
    </td>

    <td>
      <Skeleton width="90%" height="2em" />
    </td>
  </tr>
);
